export var TrackEventName;
(function (TrackEventName) {
    TrackEventName["VIEW_CONTENT"] = "ViewContent";
    TrackEventName["SEARCH"] = "Search";
    TrackEventName["ADD_TO_CART"] = "AddToCart";
    TrackEventName["ADD_TO_WISHLIST"] = "AddToWishlist";
    TrackEventName["INITIATE_CHECKOUT"] = "InitiateCheckout";
    TrackEventName["ADD_PAYMENT_INFO"] = "AddPaymentInfo";
    TrackEventName["PURCHASE"] = "Purchase";
    TrackEventName["LEAD"] = "Lead";
    TrackEventName["COMPLETE_REGISTRATION"] = "CompleteRegistration";
    TrackEventName["CUSTOM_EVENT"] = "CustomEvent";
    TrackEventName["REMOVE_FROM_CART"] = "RemoveFromCart";
    TrackEventName["CHECKOUT_STEP"] = "CheckoutStep";
})(TrackEventName || (TrackEventName = {}));
//# sourceMappingURL=track-event.js.map